"use strict";
/**
 * Protocols for APIs
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
//#region For APIs
__exportStar(require("./response"), exports);
__exportStar(require("./response-data-item"), exports);
__exportStar(require("./hypermedia"), exports);
__exportStar(require("./links"), exports);
//#region Forms
__exportStar(require("./forms/project-export-form"), exports);
__exportStar(require("./forms/defects/defects-update-form"), exports);
//#endregion
//#region Queues
__exportStar(require("./bull-queue/queue-names"), exports);
__exportStar(require("./bull-queue/job-progress"), exports);
//#endregion
//#region HTML Forms
__exportStar(require("./forms/job-list-filter-form"), exports);
__exportStar(require("./forms/project-export-form"), exports);
//#endregion
//#endregion
/**
 * Protocols for socket connections
 */
// #region For socket connections
__exportStar(require("./socket/socket-io-commons"), exports);
__exportStar(require("./socket/namespaces"), exports);
__exportStar(require("./socket/events/backup-event"), exports);
__exportStar(require("./socket/events/project-event"), exports);
__exportStar(require("./socket/data/equipment-update-data"), exports);
//#endregion
//# sourceMappingURL=index.js.map